<template>
  <div class="registerwrap">
    <logohead></logohead>
    <el-form
      ref="registerForm"
      class="loginall"
      :model="registerDate"
      :rules="rules"
    >
      <el-form-item prop="mobile">
        <el-input
          v-model="registerDate.mobile"
          placeholder="手机号"
          class="login-form-input"
        ></el-input>
      </el-form-item>
      <el-form-item prop="pass">
        <el-input
          v-model="registerDate.pass"
          class="login-form-input"
          placeholder="密码"
          show-password
        ></el-input>
      </el-form-item>
      <el-form-item prop="imgcode">
        <el-input placeholder="请输入右侧验证码" v-model="registerDate.imgCode">
          <template slot="append"
            ><img ref="codeimg" :src="imgcode" @click="getImgCode" alt=""
          /></template>
        </el-input>
      </el-form-item>
      <el-form-item class="code">
        <div class="getcodebox">
          <el-input
            placeholder="获取验证码"
            v-model="registerDate.code"
            class="getcode"
          >
          </el-input>
          <div class="getmycode" v-show="isclick" @click="getCode">获取</div>
          <div class="getmycode isnoneclick" v-show="!isclick" width="117px">
            重新发送 ({{ timecount }}s)
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button class="usersub" @click="register">注册</el-button>
      </el-form-item>
      <el-form-item class="elseoption">
        <div class="goelse">
          <router-link to="/login">已有账号？立即登录</router-link>
        </div>
      </el-form-item>
      <loginelse></loginelse>
    </el-form>
  </div>
</template>

<script>
import { isMobile, isPwd, encryptStr } from "utils/core/kernel";
import { BENDI } from "apiurl/index";
import { getCode, registerMobile } from "apiurl/login";
export default {
  data() {
    var validateName = (rule, value, callback) => {
      if (isMobile(value)) {
        callback();
      } else {
        callback(new Error("请输入正确的手机号"));
      }
    };
    var validatePass = (rule, value, callback) => {
      if (isPwd(value)) {
        callback();
      } else {
        callback(new Error("请输入6-20位字母数字符号中的两种"));
      }
    };
    return {
      registerDate: {
        mobile: "",
        imgCode: null,
        code: null,
        pass: ""
      },
      checked: true,
      rules: {
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: validateName, trigger: "blur" }
        ],
        imgCode: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        pass: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: validatePass, trigger: "blur" }
        ]
      },
      imgcode: "", //图片验证码
      timestamp: null, // 保存时间戳
      isclick: true, //是否可发送验证码
      timecount: 60, //倒计时秒数
      timer: null //计时对象
    };
  },
  created() {
    this.$nextTick(() => {
      /* 获取验证码 */
      this.getImgCode();
    });
  },
  methods: {
    /* 获取图片验证码 */
    getImgCode() {
      let timestamp = new Date().getTime();
      this.timestamp = timestamp;
      this.$refs.codeimg.setAttribute(
        "src",
        `${BENDI}/auth/image/captcha?timestamp=${timestamp}`
      );
    },
    /* 获取手机验证码 */
    async getCode() {
      if (this.registerDate.mobile && this.registerDate.imgCode) {
        let coderes = await getCode({
          mobile: encryptStr(this.registerDate.mobile),
          captcha: this.registerDate.imgCode,
          timestamp: this.timestamp
        });
        if (coderes.success) {
          this.$message({
            message: "短信已发送到您的手机！",
            type: "success"
          });
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.timecount = TIME_COUNT;
            this.isclick = false;
            this.timer = setInterval(() => {
              if (this.timecount > 1 && this.timecount <= TIME_COUNT) {
                this.timecount--;
              } else {
                this.isclick = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        } else {
          this.$message.error(coderes.message);
          /* 再次点击刷新图片验证码 */
          if (coderes.code === 20004) {
            this.getImgCode();
          }
        }
      } else {
        this.$message.error("请输入手机号和图片验证码");
      }
    },
    /* 手机号注册 */
    async register() {
      let res = await registerMobile({
        code: this.registerDate.code,
        mobile: encryptStr(this.registerDate.mobile),
        password: encryptStr(this.registerDate.pass)
      });
      if (res.success) {
        this.$message({
          message: "注册成功！",
          type: "success"
        });
        this.$router.push("/login");
      }
    }
  },
  mounted() {}
};
</script>
<style>
.el-input-group__append {
  border-radius: 0px;
}
.el-input-group__append img {
  display: block;
  width: 80px;
  height: 45px;
}
.getcode .el-input-group__append {
  background: rgba(72, 162, 223, 1);
  color: rgba(255, 255, 255, 1);
  text-align: center;
  color: #fff;
}
.getcodebox {
  position: relative;
}
.getmycode {
  position: absolute;
  cursor: pointer;
  width: 80px;
  height: 46px;
  background: rgba(72, 162, 223, 1);
  color: rgba(255, 255, 255, 1);
  text-align: center;
  color: #fff;
  top: 0px;
  right: 0px;
  text-align: center;
  line-height: 46px;
}
.isnoneclick {
  width: 117px;
}
</style>

<style lang="stylus" scoped>
.el-form
    width 300px
    margin 60px auto 0
    .goelse
        color #48A2DF
        a
            font-size 14px
            color #48A2DF
    .loginelse
        margin-top 40px
        display flex
        justify-content space-between
        a
            width 42px
            height 42px
</style>
